exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:1200px) and (max-width:1699px){.group .large .value{font-size:50px}.group .medium .value{font-size:32px}.group .small .value{font-size:20px}}", ""]);

// exports
